import React from 'react'
import { AlertCircle, Trash2 } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogClose,
  Button,
} from '../ui'
import { LoadingSpinner } from '../ui/loading-states'

interface DeleteStaffingLimitDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => Promise<void>
  isLoading?: boolean
  error?: Error | null
}

export function DeleteStaffingLimitDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
  error = null,
}: DeleteStaffingLimitDialogProps) {
  const handleDelete = async () => {
    try {
      await onConfirm()
    } catch (err) {
      console.error('Delete error:', err)
    }
  }

  const handleClose = () => {
    if (!isLoading) {
      onOpenChange(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <Trash2 className="h-5 w-5" />
            Удалить лимит
          </DialogTitle>
          <DialogDescription>
            Вы уверены, что хотите удалить этот лимит штатного расписания?
          </DialogDescription>
          {!isLoading && <DialogClose onClose={handleClose} />}
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-muted-foreground">
            Это действие нельзя отменить. После удаления лимита ограничения
            перестанут действовать.
          </p>
        </div>

        {error && (
          <div className="flex items-center p-3 text-sm text-red-700 bg-red-100 rounded-md">
            <AlertCircle className="h-4 w-4 mr-2 flex-shrink-0" />
            <span>
              {(error as any)?.message || 'Произошла ошибка при удалении лимита'}
            </span>
          </div>
        )}

        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={handleClose}
            disabled={isLoading}
          >
            Отменить
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleDelete}
            disabled={isLoading}
            className="min-w-[100px]"
          >
            {isLoading ? (
              <>
                <LoadingSpinner className="mr-2 h-4 w-4" />
                Удаление...
              </>
            ) : (
              <>
                <Trash2 className="mr-2 h-4 w-4" />
                Удалить
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
